<div class="confirm-dialog" [ngClass]="{'dark-theme': isDark}">

  <div class="guardar-header d-flex align-items-center">
    <h2 class="guardar-title m-0">
      <mat-icon class="me-2">warning_amber</mat-icon>
      {{ data.titulo }}
    </h2>
  </div>

  <div class="guardar-content">
    <p class="confirm-msg">{{ data.mensaje }}</p>
  </div>

  <div class="guardar-actions d-flex justify-content-end gap-2">
    <button mat-stroked-button (click)="onCancelar()">
      <mat-icon class="me-1">close</mat-icon>
      {{ data.botonCancelar }}
    </button>
    <button mat-raised-button color="warn" (click)="onConfirmar()">
      <mat-icon class="me-1">delete_outline</mat-icon>
      {{ data.botonConfirmar }}
    </button>
  </div>

</div>
